import classNames from 'classnames';
import type { FC } from 'react';
import type { InteractiveAtomSize } from '../utils/InteractiveAtomProps';

export type FormFieldErrorSize = InteractiveAtomSize;

export type FormFieldErrorProps = {
  className?: string;
  error?: string;
  size?: FormFieldErrorSize;
  disabled?: boolean;
};

const sizeClassName: { [Key in FormFieldErrorSize]: string } = {
  small: 'text-xs',
  default: 'text-xs',
  large: 'text-sm',
};

export const FormFieldError: FC<FormFieldErrorProps> = ({
  className,
  error,
  size = 'default',
  disabled,
}) =>
  error && (
    <span
      className={classNames(
        disabled ? 'text-status-disabled-dark' : 'text-status-error',
        sizeClassName[size],
        className,
      )}
      role='alert'
    >
      {error}
    </span>
  );
